export default __webpack_public_path__ + "static/media/hamburguer.ba0b804c.jpg";